














import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { ErrorsModule } from '@/store/modules/error'
import i18n from '@/i18n'
import { PaintingByNumbersModule } from '../../../store/modules/paintingByNumbers';

@Component({
    name: 'warning'
})
export default class Warning extends Vue {

    get keys() {
        return ErrorsModule.keys
    }

    titleDeclined(key: string) {
        return (key.includes('forbiddenCharacters') || key.includes('invalidCharacters'))
    }

    imageDeclined(key: string) {
        let error = ErrorsModule.errors[key]
        if (error.includes(i18n.t('warningImageDeclined').toString()) || error.includes(i18n.t('tooBig').toString())) {
            return true
        }
        return false
    }

    maxAssetsReached(key: string) {
        let error = ErrorsModule.errors[key]
        if (error.includes(i18n.t('maxAssetsWarning').toString())) {
            return true
        }
        return false
    }

    showWarning(key: string) {
        if (this.titleDeclined(key)) {
            return PaintingByNumbersModule.showTitle
        }
        return this.keys.length > 0 && (((PaintingByNumbersModule.showImageUpload || PaintingByNumbersModule.showPainting) && this.imageDeclined(key)) ||
        (PaintingByNumbersModule.showImageUpload || PaintingByNumbersModule.showPainting) && this.maxAssetsReached(key) ||
        (PaintingByNumbersModule.showPainting && PaintingByNumbersModule.userFormat !== ""))
    }

    message(key: string) {
        return ErrorsModule.errors[key]
    }

    onClose(key: string) {
        ErrorsModule.SetError({ key })
    }
}
